import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form'
import { loadLayouts, loadSetting } from '../../redux';
import { CopyButton, SelectField } from '../../components';
import { Row, Col, Card, CardBody, CardText, CardTitle, ButtonGroup, Button } from "reactstrap";
import _ from "lodash";

import './PdfLayoutMappings.css';

const PdfLayoutMappings = ({ name, type, removeLayout, id, pricingName }) => {
    const storedLayouts = useSelector(state => state.layouts.layouts);

    const dispatch    = useDispatch();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        dispatch(loadLayouts());
        dispatch(loadSetting('default'));
    }, []);

    const layouts = React.useMemo(() => {
        return (storedLayouts || []).filter(l => l.type === type);
    }, [type, storedLayouts]);

    const layoutOptions = React.useMemo(() => target => {
        return layouts?.filter(l => l.target === target).map(layout => ({
            key: layout._id,
            value: layout._id,
            text: layout.name[i18n.language]
        }));
    }, [layouts]);

    const targets = React.useMemo(() => _.uniq(layouts.map(l => l.target)), [layouts]);

    const onRemoveLayout = () => {
        removeLayout(id);
    }

    return (
        <div className="PdfLayoutMappings">
            <Card>
                <CardBody>
                    <CardTitle>
                        <div className="d-flex justify-between">
                            {id ? (pricingName || '-') :  t('salepoints.default')}
                            <ButtonGroup size="xs">
                                {id && <CopyButton size="xs" color="info" textToCopy= { id } />}
                                {removeLayout &&
                                    <Button type="button" size="xs" color="danger" onClick={onRemoveLayout}><i className="fa fa-times"></i></Button>
                                }
                            </ButtonGroup>
                        </div>
                    </CardTitle>
                    <Row>
                        {targets?.map(target => (
                            <Col key={target} className="PdfLayoutMapping" sm={3}>
                                <Card className="h-auto inner-card">
                                    <CardBody>
                                        <CardTitle className="small">
                                            {t(`layouts.target_${target}`)}
                                        </CardTitle>
                                        <CardText tag="div">
                                            <SelectField name={`${name}.${target}`} options={layoutOptions(target)} placeholder={t('layouts.please_choose_a_layout')} />
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}

export default PdfLayoutMappings;
